import "@/App.css";
import '@/locales/public.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import QRPage from "@/pages/QRPage";
import BbqPage from "@/pages/BbqPage";
import BbqReviewsPage from "@/pages/BbqReviewsPage";
import BbqPosterPage from "@/pages/BbqPosterPage";
import BbqAdminApprovePage from "@/pages/BbqAdminApprovePage";
import BbqAdminDashboard from "@/pages/BbqAdminDashboard";
import BbqPaymentSuccessPage from "@/pages/BbqPaymentSuccessPage";
import DynamicPage from "@/pages/DynamicPage";
import SiteLayout from "@/platform/SiteLayout";
import HomePage from "@/platform/HomePage";
import EventsPage from "@/platform/EventsPage";
import EventDetailPage from "@/platform/EventDetailPage";
import SocialPage, { ClubDetailPage } from "@/platform/SocialPage";
import ContentPageRoute from "@/platform/ContentPages";
import PlatformAdminPage from "@/platform/admin/PlatformAdminPage";

function App() {
  return (
    <I18nProvider>
      <SmoothScrollProvider>
        <div className="App min-h-screen">
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/social" element={<SocialPage />} />
                <Route path="/social/:slug" element={<ClubDetailPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/events/:slug" element={<EventDetailPage />} />
                <Route path="/settle" element={<ContentPageRoute kind="settle" />} />
                <Route path="/about" element={<ContentPageRoute kind="about" />} />
              </Route>
              <Route path="/admin" element={<PlatformAdminPage />} />
              <Route path="/admin/events" element={<PlatformAdminPage />} />
              <Route path="/qr" element={<QRPage />} />
              <Route path="/bbq" element={<BbqPage />} />
              <Route path="/bbq/reviews" element={<BbqReviewsPage />} />
              <Route path="/bbq/poster" element={<BbqPosterPage />} />
              <Route path="/bbq/payment/success" element={<BbqPaymentSuccessPage />} />
              <Route path="/bbq/admin" element={<BbqAdminDashboard />} />
              <Route path="/bbq/admin/:id" element={<BbqAdminApprovePage />} />
              <Route path="/:slug" element={<DynamicPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </SmoothScrollProvider>
    </I18nProvider>
  );
}

export default App;
